import { readable } from "svelte/store";
export const research = readable([], (set) => {
    fetch('./data/research.json').then((data) => data.json()).then((rec) => {
        const list = rec;
        set(list.sort((a, b) => { return (a.title < b.title) ? -1 : 1; }));
    }).catch(() => {
        set(null);
    });
});
